import script from "./SafeWord.vue?vue&type=script&setup=true&lang=ts"
export * from "./SafeWord.vue?vue&type=script&setup=true&lang=ts"

import "./SafeWord.vue?vue&type=style&index=0&id=21fb24ac&scoped=true&lang=less"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.44_vue@3.5.44_typescript@4.9.5__webpack@5.112.2_2b87b21da4aed600185acfcb8e880229/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21fb24ac"]])

export default __exports__